import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { WsCreateEmployeeEventRequest, WsCreateUpdateEmployeeTimeSheduleRequest, WsDeleteEmployeeEventsRequest, WsEmployee, WsEmployeeLookup, WsList, WsProdCalendarDay, WsScheduleLookup, WsUpdateEmployeeEventRequest } from "../components/work-schedule/core/work-schedule.models";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { ActionResult } from "../models/core/ActionResult";
import { NotificationType } from "../../core/services/notification-type";

@Injectable()
export class WorkScheduleService extends DataService<object, object> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'work-schedule';
        this.controllerVersion = 3;
    }

    public getProdCalendar(year: number): Observable<WsProdCalendarDay[]> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/get-prod-calendar/${year}`);
    }

    public getEmployeesLookup(): Observable<WsEmployeeLookup[]> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/get-employees-lookup`);
    }

    public getEmployees(page: number, pageSize: number, date: Date, empId: number = null): Observable<WsList<WsEmployee>> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/get-employees?page=${page}&pageSize=${pageSize}&empId=${empId}&date=${this.toUtcMidnightIso(date)}`);
    }

    public createEmployeeEvent(request: WsCreateEmployeeEventRequest): Observable<ActionDataResult<number>> {
        return this.postQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/create-employee-event`, request,
            null, true, NotificationType.Toast
        );
    }

    public createEmployeeTimeShedule(request: WsCreateUpdateEmployeeTimeSheduleRequest): Observable<ActionResult> {
        return this.postQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/create-employee-time-shedule`, request,
            null, true, NotificationType.Toast
        );
    }

    public deleteEmployeeEvents(request: WsDeleteEmployeeEventsRequest): Observable<ActionResult> {
        return this.postQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/delete-employee-events`, request,
            null, true, NotificationType.Toast
        );
    }

    public updateEmployeeEvent(request: WsUpdateEmployeeEventRequest): Observable<ActionDataResult<number>> {
        return this.putQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/update-employee-event`, request);
    }

    public updateEmployeeTimeSchedule(request: WsCreateUpdateEmployeeTimeSheduleRequest): Observable<ActionResult> {
        return this.putQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/update-employee-time-schedule`, request);
    }

    public getTimeSchedulesLookup(): Observable<WsScheduleLookup[]> {
        return this.getQuery(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/get-time-schedules-lookup`);
    }

    private toMoscowIsoString(date: Date): string {
        // Создаём дату как будто она в UTC, но сдвигаем на +3 часа
        const moscow = new Date(date.getTime() - date.getTimezoneOffset() * 60000 + 3 * 60 * 60 * 1000);
        return moscow.toISOString();
    }

    private toUtcIsoString(date: Date): string {
        return date.toISOString();
    }

    private toUtcMidnightIso(date: Date): string {
        const utcMidnight = new Date(Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            0, 0, 0, 0
        ));

        return utcMidnight.toISOString();
    }
}
